import { z } from "zod";

export const vendorSchema = z
  .object({
    name: z
      .string()
      .min(1, "Vendor name is required.")
      .max(100, "Vendor name must be 100 characters or fewer."),
    type: z.enum(["mapped", "ocr-exception", "review-queue"]),
    defaultGlNumber: z.string().optional(),
    defaultCard: z.string().optional(),
    glAccountDescription: z
      .string()
      .min(1, "GL description is required.")
      .max(500, "GL description must be 500 characters or fewer."),
    notes: z
      .string()
      .max(500, "Notes must be 500 characters or fewer.")
      .optional(),
  })
  .superRefine((data, ctx) => {
    if (data.type === "mapped") {
      if (!data.defaultGlNumber || data.defaultGlNumber.trim().length === 0) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          path: ["defaultGlNumber"],
          message: "GL account is required for mapped vendors.",
        });
      }
      if (!data.defaultCard || data.defaultCard.trim().length === 0) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          path: ["defaultCard"],
          message: "Bank account is required for mapped vendors.",
        });
      }
    }
  });

export type VendorFormData = z.infer<typeof vendorSchema>;
